import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../../SuperAdmin/Controller/Client/UpdateCompanyController";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
function CreateAgreement() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ContractPrefix: '', CoSetupID: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);

    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        async function fetchCompanySetup() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/');
                };
                const ClientID = localStorage.getItem('CompanyID');
                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                setFormData({
                    ContractPrefix: companySetup[0].ContractPrefix,
                    CoSetupID: companySetup[0].CoSetupID
                });
            } catch (error) {
                console.error('Error fetching company setup:', error);
            }
        }
        fetchCompanySetup();
    }, [navigate]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {

        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(formData, setFormData, setErrors, redirectCallback, redirectUserList);
        const updatedCompanySetup = await CompanySetupController.GetCompanyByID(redirectCallback, formData.CoSetupID);
        setFormData(updatedCompanySetup[0] || {});
        window.scrollTo(0, 0);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Agreement Setting" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Agreement Auto Prefix</label>
                    <div className="col-sm-4">
                        <input type="hidden" className="form-control" name="CoSetupID" value={formData.CoSetupID} onChange={handleFieldChange} />
                        <input type="text" className="form-control" name="ContractPrefix" value={formData.ContractPrefix} onChange={handleFieldChange} />
                        {errors.ContractPrefix && <div style={{ color: 'red' }}>{errors.ContractPrefix}</div>}
                    </div>
                </div>
                <div className="row" style={{ "marginLeft": "0px", "float": "right", "marginRight": "0px" }}>
                    <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateAgreement;
